import React from 'react';
import PhysioVideoApp from './PhysioVideoApp';

function App() {
  return <PhysioVideoApp />;
}

export default App;